<template>
  <div class="layout">
    <!-- <keep-alive> -->
      <router-view />
    <!-- </keep-alive> -->
    <foot />
    <side-menu />
  </div>
</template>

<script>
import Foot from '@/components/Foot'
import SideMenu from '@/components/Menu'

export default {
  components: {
    Foot,
    SideMenu
  }
}
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  width: 96rem;
  margin: 0 auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/pages/Layout.vue